import { createSlice } from "@reduxjs/toolkit";

const patientSlice = createSlice({
    name: 'patients',
    initialState: { patients: null },
    reducers: {
        setPatients: (state, action) => {
            state.patients = action.payload
        }
    }
});

export const { setPatients } = patientSlice.actions;
export default patientSlice.reducer;